module.exports = __webpack_public_path__ + "static/img/bgscimg5moxin5.4f2e579.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rppghealth/bgscimg5moxin5.png
// module id = LGlK
// module chunks = 5